<button id="contact-us-overlay" class="desktop" (click)="openDialog()">Contact Us</button>
<button id="contact-us-overlay" class="mobile" (click)="openDialog()"><i class="fas fa-comment-dots fa-lg"></i></button>
